import { getAccess } from 'ai-settings-ui-library/clients/Access';
import { registerQuery, useQuery } from 'data-fetching-client';
const FETCH_AI_SETTINGS_ACCESS = registerQuery({
  fieldName: 'aiAccessControls',
  fetcher: getAccess
});
const DEFAULT_SETTINGS = {
  generativeAiEnabled: false,
  copilotEnabled: false,
  fileDataEnabled: false,
  crmPropertiesEnabled: false,
  conversationDataEnabled: false
};
export const useFetchAiSettingsAccess = () => {
  const {
    loading,
    data
  } = useQuery(FETCH_AI_SETTINGS_ACCESS);
  const accessControls = (data === null || data === void 0 ? void 0 : data.aiAccessControls) || {};
  return Object.assign({
    loading
  }, DEFAULT_SETTINGS, accessControls);
};